// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"styles_loaderWrapper__2E_w_"};